var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandsFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4626 751.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3c80f6;}.cls-2{fill:none;}.cls-17,.cls-2,.cls-7{stroke:#000;stroke-miterlimit:10;}.cls-2,.cls-7{stroke-linecap:round;stroke-width:2px;}.cls-19,.cls-3{fill:#fff;}.cls-4{fill:#d7d7d7;}.cls-5{fill:#b5b5b5;}.cls-6{fill:#e8e8e8;}.cls-8{fill:#ff1e00;}.cls-9{fill:#eaeaea;}.cls-10{fill:#d9d9d9;}.cls-11{fill:#848484;}.cls-12{fill:#a6a6a6;}.cls-13{fill:#b7b7b7;}.cls-14{fill:#828282;}.cls-15{opacity:0.1;}.cls-16{fill:#a4a4a4;}.cls-17,.cls-18{opacity:0.6;}.cls-19{opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2363.32,193.56a12,12,0,0,1,22.87-5.11l1.45-.32-.19-2a12,12,0,0,1,23.8-3.3l.4-.09a11.76,11.76,0,0,1,.87-2.77,43.39,43.39,0,0,1-1.07-9.54v-2.24a6.53,6.53,0,0,1,11.15-4.62l13.67,13.67h0l7.2-72.66a9.32,9.32,0,0,1,9.26-8.39h0a9.3,9.3,0,0,1,9.3,9.3l0,106.83c0,.53.06,1,.06,1.58v34.89c0,.61,0,1.21-.05,1.81l.05,500.37h-98.79V193.56Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2363.32,
    y1: 193.56,
    x2: 2363.32,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2436.27,177.26l7.2-72.66a9.32,9.32,0,0,1,9.26-8.39h0a9.3,9.3,0,0,1,9.3,9.3l.08,645.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2418.57,292.34a43.53,43.53,0,0,0,43.54-43.53V213.92a26.15,26.15,0,0,0-7.65-18.47l-31.86-31.86a6.53,6.53,0,0,0-11.15,4.62v2.24a43.53,43.53,0,0,0,12.75,30.78l7.51,7.51a4.31,4.31,0,0,1-.09,6.24,45,45,0,0,0-14.56,33.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2409.16,208.42l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.22,22.27a9.8,9.8,0,0,0,9.75,8.82h0A9.8,9.8,0,0,0,2409.16,208.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2412.54,179.94a12,12,0,0,0-1,6.21l2.23,22.27a9.8,9.8,0,0,0,9.74,8.82h0a9.8,9.8,0,0,0,9.31-6.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2385.1,217.13l2.22-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.79,9.79,0,0,0,9.74,8.82h0A9.8,9.8,0,0,0,2385.1,217.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2277,197a12,12,0,0,0-24-.87h-.13l.65-6.54a12,12,0,0,0-12-13.22h0a12,12,0,0,0-11.72,9.29h0a43.29,43.29,0,0,0,1.63-11.75v-2.24a6.53,6.53,0,0,0-11.15-4.62l-18,18-.19,0a12,12,0,0,0-9.26-4.36h0a12,12,0,0,0-12,13.17v21.89c0,.53,0,1.05,0,1.59v34.88c0,.62,0,1.24,0,1.85l0,496.89H2277V197Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2276.99,
    y1: 197,
    x2: 2276.99,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2180.81,
    y1: 193.52,
    x2: 2180.76,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2224.29,295.79a43.53,43.53,0,0,1-43.53-43.54V217.37a26.11,26.11,0,0,1,7.65-18.47L2220.26,167a6.53,6.53,0,0,1,11.15,4.62v2.24a43.52,43.52,0,0,1-12.75,30.78l-7.51,7.51a4.32,4.32,0,0,0,.09,6.24,44.92,44.92,0,0,1,14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2182.28,208.58,2180.82,194a12,12,0,0,1,12-13.23h0a12,12,0,0,1,9.26,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2228.9,188.28a9.65,9.65,0,0,1-.06,1.31l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.82h0a9.8,9.8,0,0,1-4.47-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2255.22,220.58,2253,198.31a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.81h0A9.79,9.79,0,0,1,2255.22,220.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2231.78,211.86l-2.22-22.27a12,12,0,0,1,12-13.22h0a12,12,0,0,1,12,13.22l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0A9.8,9.8,0,0,1,2231.78,211.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M691.17,197a12,12,0,0,0-24-.87H667l.65-6.54a12,12,0,0,0-12-13.22h0A12,12,0,0,0,644,185.66h0a43.67,43.67,0,0,0,1.62-11.75v-2.24A6.53,6.53,0,0,0,634.44,167l-18,18-.19,0a12,12,0,0,0-9.27-4.36h0a12,12,0,0,0-12,13.17v21.89c0,.52-.05,1.05-.05,1.59v34.88c0,.62,0,1.24.05,1.85L594.93,751h96.24V197Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 691.17,
    y1: 197,
    x2: 691.17,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 594.99,
    y1: 193.52,
    x2: 594.93,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M638.46,295.79a43.53,43.53,0,0,1-43.53-43.54V217.37a26.11,26.11,0,0,1,7.65-18.47L634.44,167a6.53,6.53,0,0,1,11.14,4.62v2.24a43.52,43.52,0,0,1-12.75,30.78l-7.51,7.51a4.32,4.32,0,0,0,.09,6.24A44.92,44.92,0,0,1,640,251.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M596.45,208.58,595,194a12,12,0,0,1,12-13.23h0a12,12,0,0,1,9.27,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M643.08,188.28c0,.43,0,.87-.06,1.31l-2.23,22.27a9.79,9.79,0,0,1-9.75,8.82h0a9.8,9.8,0,0,1-4.47-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M669.39,220.58l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.27a9.79,9.79,0,0,1-9.75,8.81h0A9.79,9.79,0,0,1,669.39,220.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M646,211.86l-2.23-22.27a12,12,0,0,1,12-13.22h0a12,12,0,0,1,12,13.22l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,646,211.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1785.63,197a12,12,0,0,0-23.24-4.21l-1.18-.21.3-3a12,12,0,0,0-23.82-3.24l7.57-77.07a8.77,8.77,0,0,0-17.33-2.52l-14,72.74-2.84,2.84-14.58-75.58a8.77,8.77,0,0,0-17.33,2.52l7.54,76.87q.21,2.13.21,4.26v25.43c0,.51-.05,1-.05,1.53v34.88c0,.57,0,1.13,0,1.69l0,497.05h98.78V197Zm-48.13-8.73h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1785.63,
    y1: 197,
    x2: 1785.63,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1711.06,182.34l-14.58-75.58a8.77,8.77,0,0,0-8.61-7.1h0a8.76,8.76,0,0,0-8.72,9.62l7.54,76.87q.21,2.13.21,4.26L1686.85,751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1737.5,188.28l7.76-79a8.77,8.77,0,0,0-8.73-9.62h0a8.75,8.75,0,0,0-8.6,7.1l-14,72.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1730.38,295.79a43.53,43.53,0,0,1-43.53-43.54V217.37a26.11,26.11,0,0,1,7.65-18.47L1726.36,167a6.53,6.53,0,0,1,11.14,4.62v2.24a43.52,43.52,0,0,1-12.75,30.78l-7.51,7.51a4.32,4.32,0,0,0,.09,6.24,44.92,44.92,0,0,1,14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1739.79,211.86l-2.23-22.27a12,12,0,0,1,12-13.22h0a12,12,0,0,1,12,13.22l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0A9.79,9.79,0,0,1,1739.79,211.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1763.86,220.58l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.81h0A9.79,9.79,0,0,1,1763.86,220.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1983.21,214.29a12,12,0,0,1,24-.87h.13l-.65-6.54a12,12,0,0,1,12-13.23h0a12,12,0,0,1,11.72,9.29h0a43.63,43.63,0,0,1-1.63-11.75v-2.24a6.53,6.53,0,0,1,11.15-4.61l18,18h.19a12,12,0,0,1,9.26-4.35h0a12,12,0,0,1,12,13.17v21.88c0,.53.06,1.06.06,1.59v34.89c0,.62,0,1.23,0,1.85l0,479.6h-96.24V214.29Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1983.21,
    y1: 214.29,
    x2: 1983.21,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2079.39,
    y1: 210.81,
    x2: 2079.45,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2035.91,313.07a43.53,43.53,0,0,0,43.54-43.53V234.65a26.17,26.17,0,0,0-7.65-18.47l-31.86-31.85a6.53,6.53,0,0,0-11.15,4.61v2.24A43.53,43.53,0,0,0,2041.54,222l7.51,7.52a4.31,4.31,0,0,1-.09,6.24,44.92,44.92,0,0,0-14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2077.92,225.86l1.47-14.62a12,12,0,0,0-12-13.23h0a12,12,0,0,0-9.26,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2031.3,205.56a9.72,9.72,0,0,0,.06,1.32l2.23,22.27a9.8,9.8,0,0,0,9.74,8.82h0a9.74,9.74,0,0,0,4.47-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2005,237.86l2.22-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.79,9.79,0,0,0,9.74,8.82h0A9.8,9.8,0,0,0,2005,237.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2028.42,229.15l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.8,9.8,0,0,0,9.74,8.82h0A9.8,9.8,0,0,0,2028.42,229.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1985.24,125.78h0a9.15,9.15,0,0,0-8.75,6.46L1956.62,197h0a12,12,0,0,0-12-11.93h0a12,12,0,0,0-12,13.23l.34,3.39-2.79.55-.39-2.38a12,12,0,1,0-23.12,6.2l.29.78-2,.4a12,12,0,0,0-17-5.47h0a12,12,0,0,0-3.75,17.44l1.22,1.7L1871,212.55a43.56,43.56,0,0,0-33.19-4.31l-1.86.51a6.53,6.53,0,0,0-1.56,12l30.41,17.55a26.1,26.1,0,0,1,12.17,15.86l4.41,16.45a44,44,0,0,0,3.08,8.16h0V751h98.79v-550a42.76,42.76,0,0,1,.71-7.82l10.31-56.55A9.14,9.14,0,0,0,1985.24,125.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1956.62,197l19.87-64.76a9.15,9.15,0,0,1,8.75-6.46h0a9.14,9.14,0,0,1,9,10.79l-10.31,56.55a42.76,42.76,0,0,0-.71,7.82V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1884.42,
    y1: 278.73,
    x2: 1884.42,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1934.66,301.36a43.53,43.53,0,0,1-53.32-30.79l-4.41-16.45a26.1,26.1,0,0,0-12.17-15.86l-30.41-17.55a6.53,6.53,0,0,1,1.56-12l1.86-.51a43.56,43.56,0,0,1,33.19,4.31l16.88,9.75c3.59,2.07,9.51,5.39,13.23,7.23a44.93,44.93,0,0,1,23.61,28.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1934.84,220.57l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0A9.79,9.79,0,0,1,1934.84,220.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1914.56,227l-7.92-20.93a12,12,0,0,1,8.14-15.88h0a12,12,0,0,1,15,9.68l3.62,22.09a9.8,9.8,0,0,1-7.14,11h0A9.79,9.79,0,0,1,1914.56,227Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1885.44,220.91l-1.22-1.7a12,12,0,0,1,3.75-17.44h0a12,12,0,0,1,17,5.47l9.21,20.39a9.8,9.8,0,0,1-1.27,10.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2182.79,91a9.15,9.15,0,0,0-8.75,6.47l-19.87,64.75h0a12,12,0,0,0-23.64-3l-.88-.11a12.43,12.43,0,0,0-.62-1.71,43.3,43.3,0,0,0,1.07-9.53v-2.24a6.53,6.53,0,0,0-11.15-4.62l-14.82,14.82h0L2081.74,80a9,9,0,0,0-17.54,4.3L2078.64,158a44.27,44.27,0,0,1,.81,8.36V751h101.31V166.11a43.54,43.54,0,0,1,.7-7.81l10.32-56.56A9.14,9.14,0,0,0,2182.79,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2154.17,162.17,2174,97.42a9.15,9.15,0,0,1,8.75-6.47h0a9.14,9.14,0,0,1,9,10.79l-10.32,56.56a43.54,43.54,0,0,0-.7,7.81V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2104.13,155.74,2081.74,80a9,9,0,0,0-8.67-6.47h0a9,9,0,0,0-8.87,10.77L2078.64,158a44.27,44.27,0,0,1,.81,8.36V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2123,269.67a43.53,43.53,0,0,1-43.53-43.54V191.25a26.11,26.11,0,0,1,7.65-18.47L2119,140.92a6.53,6.53,0,0,1,11.15,4.62v2.24a43.55,43.55,0,0,1-12.75,30.78l-7.51,7.51a4.32,4.32,0,0,0,.09,6.24,44.92,44.92,0,0,1,14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2132.39,185.74l-2.23-22.27a12,12,0,0,1,12-13.22h0a12,12,0,0,1,12,13.22l-2.23,22.27a9.79,9.79,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,2132.39,185.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2129,157.27a12,12,0,0,1,1,6.2l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0a9.79,9.79,0,0,1-9.31-6.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 215.81,
    y: 1.16,
    width: 87.06,
    height: 130.6,
    transform: "translate(128.02 299.76) rotate(-75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.18,111.19a12,12,0,0,0-12.81-4.5h0a12,12,0,0,0-8.14,15.88l3.36,8.9V751h94.46V156.54q0-20.47-1.93-40.87L292.36,97a54.39,54.39,0,0,1,.53-14.13l1.85-10.82a6.53,6.53,0,0,0-6.43-7.63,21,21,0,0,0-20.73,17.49h0a53.51,53.51,0,0,0-.32,16l2.15,16.5h0l-50.59-13.77a11.9,11.9,0,0,0,.4,7.25l1,2.7Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 201.59,
    y1: 131.47,
    x2: 201.59,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.82,100.67a11.9,11.9,0,0,0,.4,7.25l7.91,20.94a9.79,9.79,0,0,0,11.7,6h0a9.79,9.79,0,0,0,7.13-11l-2.72-16.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247,108.21l.36,3.65a9.8,9.8,0,0,0,9.75,8.82h0a9.79,9.79,0,0,0,9.45-7.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225,138.46l-3.62-22.09a12,12,0,0,0-15-9.68h0a12,12,0,0,0-8.14,15.88l7.91,20.93a9.8,9.8,0,0,0,11.7,6h0A9.8,9.8,0,0,0,225,138.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.12,203a43.53,43.53,0,0,1-43.53-43.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "269.38 114.22 185 91.61 207.53 7.51 333.68 41.31 311.14 125.41 294.59 120.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 308.45,
    y1: 34.55,
    x2: 292.22,
    y2: 95.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 258.91,
    y1: 30.29,
    x2: 240.89,
    y2: 97.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.59,296.7h0a4.74,4.74,0,0,0,1.58,9.21h0a93.55,93.55,0,0,0,90.59-70.23L332.28,86l-36.23,84.89"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.8,
    cy: 79.98,
    r: 4.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94,30.14l-2.39,8.92L224.5,35.88c-3-.41-5.05-.85-7.2-1.32l-.07.26c2.1.68,4.09,1.32,6.9,2.46l21.54,8.78-2.37,8.86-35-16.7,3-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.84,47.46l36.82,9.86L240.34,66l-36.82-9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.29,90.6l-3-.81c-6.89-1.84-9.6-6.68-7.68-13.84l.75-2.8-13.43-3.6,2.32-8.65,36.82,9.86L236,82C234.07,89.37,229.74,92.27,223.29,90.6Zm2.2-9c2.95.8,4.4.18,5-2l.45-1.66-11.62-3.11-.44,1.66c-.6,2.23.5,3.52,4,4.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.81,
    y: 65.87,
    width: 69.65,
    height: 3.48,
    transform: "matrix(-0.26, 0.97, -0.97, -0.26, 397.18, -169.54)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "278.57 66.81 286.38 37.65 289.75 38.55 282.61 65.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "287.47 64.44 294.09 39.72 297.46 40.62 290.93 64.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272.68,71.38a20.93,20.93,0,0,0-5.1,10.53h0a53.76,53.76,0,0,0-.73,11.26h0L264,103.76l-3.36-.9,18-67.27,3.36.9L272.7,71.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,83.13l1.69-6.31,1.43,1.07a7.25,7.25,0,0,0,5.21,1.4h0a7.2,7.2,0,0,1,3.44.42l13.28,5a1.69,1.69,0,0,1,1,2h0a1.69,1.69,0,0,1-1.9,1.22l-14-2.29a7.22,7.22,0,0,1-3.18-1.35h0a7.29,7.29,0,0,0-5.22-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.75,159.46a45,45,0,0,1,14.45-33.32A8.62,8.62,0,0,0,270,118.7l-2.7-20.76a53.51,53.51,0,0,1,.32-16h0a21,21,0,0,1,20.73-17.49h0a6.53,6.53,0,0,1,6.43,7.63l-1.85,10.82A54.39,54.39,0,0,0,292.36,97l1.76,18.67Q296,136,296.05,156.54V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1783.61,197.56h0a9.15,9.15,0,0,1,8.74,6.46l19.87,64.76h0a12,12,0,0,1,12-11.93h0a12,12,0,0,1,12,13.23l-.34,3.39,2.79.55.39-2.37a12,12,0,1,1,23.13,6.19l-.3.78,2,.4a12,12,0,0,1,17-5.47h0a12,12,0,0,1,3.76,17.44l-1.23,1.71,14.49-8.37a43.48,43.48,0,0,1,33.18-4.3l1.87.5a6.53,6.53,0,0,1,1.55,12L1904.08,310a26.16,26.16,0,0,0-12.17,15.86l-4.41,16.46a43.93,43.93,0,0,1-3.08,8.15h0V751h-98.79V272.72a43.46,43.46,0,0,0-.7-7.81l-10.32-56.56A9.14,9.14,0,0,1,1783.61,197.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1812.22,268.78,1792.35,204a9.15,9.15,0,0,0-8.74-6.46h0a9.14,9.14,0,0,0-9,10.79l10.32,56.56a43.46,43.46,0,0,1,.7,7.81V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1884.42,
    y1: 350.51,
    x2: 1884.42,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1834.19,373.14a43.53,43.53,0,0,0,53.31-30.78l4.41-16.46A26.16,26.16,0,0,1,1904.08,310l30.41-17.55a6.53,6.53,0,0,0-1.55-12l-1.87-.5a43.48,43.48,0,0,0-33.18,4.3L1881,294.08c-3.59,2.08-9.51,5.4-13.22,7.23a44.94,44.94,0,0,0-23.62,28.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1834,292.35l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.22,22.27a9.8,9.8,0,0,0,9.75,8.82h0A9.79,9.79,0,0,0,1834,292.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1854.28,298.78l7.92-20.94a12,12,0,0,0-8.14-15.87h0a12,12,0,0,0-15,9.68l-3.61,22.08a9.79,9.79,0,0,0,7.13,11h0A9.79,9.79,0,0,0,1854.28,298.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1883.4,292.7l1.23-1.71a12,12,0,0,0-3.76-17.44h0a12,12,0,0,0-17,5.47l-9.21,20.4a9.81,9.81,0,0,0,1.27,10.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,153.47a12,12,0,0,1,23.25-4.21l1.17-.22-.29-3a12,12,0,0,1,23.81-3.24L41.38,65.75a8.77,8.77,0,0,1,17.33-2.52l14,72.74,2.84,2.84L90.15,63.23a8.77,8.77,0,0,1,17.33,2.52l-7.54,76.87q-.21,2.13-.21,4.26v25.43c0,.51.05,1,.05,1.52v34.89c0,.57,0,1.12-.05,1.68L99.79,751H1V153.47Zm48.13-8.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.58,138.81,90.15,63.23a8.77,8.77,0,0,1,8.61-7.1h0a8.76,8.76,0,0,1,8.72,9.62l-7.54,76.87q-.21,2.13-.21,4.26L99.79,751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.13,144.75l-7.75-79a8.76,8.76,0,0,1,8.72-9.62h0a8.77,8.77,0,0,1,8.61,7.1l14,72.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.25,252.25a43.53,43.53,0,0,0,43.54-43.53V173.83a26.13,26.13,0,0,0-7.65-18.46L60.28,123.51a6.53,6.53,0,0,0-11.15,4.61v2.24a43.57,43.57,0,0,0,12.75,30.79l7.51,7.51a4.32,4.32,0,0,1-.08,6.24,44.89,44.89,0,0,0-14.57,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.84,168.33l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.22,22.27a9.8,9.8,0,0,0,9.75,8.82h0A9.79,9.79,0,0,0,46.84,168.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.25,252.25a43.53,43.53,0,0,0,43.54-43.53V173.83a26.13,26.13,0,0,0-7.65-18.46L60.28,123.51a6.53,6.53,0,0,0-11.15,4.61v2.24a43.57,43.57,0,0,0,12.75,30.79l7.51,7.51a4.32,4.32,0,0,1-.08,6.24,44.89,44.89,0,0,0-14.57,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.24,195.43a9.14,9.14,0,0,1,8.74,6.46l19.88,64.76h0a12,12,0,0,1,24.06,0h0a12,12,0,0,1,12-11.93h0a12,12,0,0,1,12,11.93h0l24.3-82.16a9,9,0,0,1,17.53,4.3l-15.06,76.93h0a43.58,43.58,0,0,1,25.77-8.34h1.93a6.53,6.53,0,0,1,4.6,11.15l-24.83,24.83a26.08,26.08,0,0,0-7.61,17l0,14.06V751H100.27V270.59a43.66,43.66,0,0,0-.71-7.82L89.24,206.22A9.15,9.15,0,0,1,98.24,195.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.86,266.65,107,201.89a9.14,9.14,0,0,0-8.74-6.46h0a9.15,9.15,0,0,0-9,10.79l10.32,56.55a43.66,43.66,0,0,1,.71,7.82V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 201.58,
    y1: 324.44,
    x2: 201.58,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175,266.65l24.3-82.16A9,9,0,0,1,208,178h0a9,9,0,0,1,8.87,10.77l-15.06,76.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.05,372.4a43.53,43.53,0,0,0,43.53-43.53v-17a26.13,26.13,0,0,1,7.65-18.47l24.83-24.82a6.53,6.53,0,0,0-4.6-11.15h-1.93a43.55,43.55,0,0,0-30.94,12.75l-15.73,15.74c-3.09,3.09-6.31,6-9.55,9a44.91,44.91,0,0,0-14.78,33.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.64,290.22,150.86,268a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.79,9.79,0,0,0,9.74,8.82h0A9.8,9.8,0,0,0,148.64,290.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.7,290.22,174.93,268a12,12,0,0,0-12-13.23h0A12,12,0,0,0,151,268l2.23,22.27A9.8,9.8,0,0,0,163,299h0A9.79,9.79,0,0,0,172.7,290.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.62,247.11a12,12,0,0,0-23.25-4.21l-1.18-.22.3-3a12,12,0,0,0-23.81-3.24l7.56-77.07a8.77,8.77,0,0,0-17.33-2.52l-14,72.74L419,232.45l-14.58-75.58a8.77,8.77,0,0,0-17.33,2.52l7.55,76.87q.21,2.13.21,4.26V266c0,.51-.05,1-.05,1.52v34.89c0,.57,0,1.12,0,1.68l0,447h98.79V247.11Zm-48.13-8.73h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 493.62,
    y1: 247.11,
    x2: 493.62,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M419,232.45l-14.58-75.58a8.75,8.75,0,0,0-8.6-7.1h0a8.77,8.77,0,0,0-8.73,9.62l7.55,76.87q.21,2.13.21,4.26L394.83,751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M445.49,238.39l7.75-79a8.76,8.76,0,0,0-8.72-9.62h0a8.77,8.77,0,0,0-8.61,7.1l-14,72.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M438.36,345.89a43.53,43.53,0,0,1-43.53-43.53V267.47A26.09,26.09,0,0,1,402.48,249l31.86-31.86a6.53,6.53,0,0,1,11.15,4.61V224a43.57,43.57,0,0,1-12.75,30.79l-7.51,7.51a4.31,4.31,0,0,0,.08,6.24,44.89,44.89,0,0,1,14.57,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.78,262l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23L467.27,262a9.8,9.8,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,447.78,262Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.84,270.68l-2.23-22.27a12,12,0,0,1,12-13.22h0a12,12,0,0,1,12,13.22l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0A9.79,9.79,0,0,1,471.84,270.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.86,142.44h0a9.15,9.15,0,0,0-8.74,6.47l-19.88,64.75h0a12,12,0,0,0-12-11.92h0a12,12,0,0,0-12,13.23l.34,3.38-2.79.56-.39-2.38a12,12,0,1,0-23.13,6.19l.29.79-2,.39a12,12,0,0,0-17-5.47h0a12,12,0,0,0-3.76,17.44l1.23,1.71-14.49-8.37a43.48,43.48,0,0,0-33.18-4.3l-1.87.5a6.53,6.53,0,0,0-1.55,12l30.41,17.56a26.1,26.1,0,0,1,12.16,15.85L293,287.24a43.26,43.26,0,0,0,3.09,8.15h0V751h98.78V217.6a43.55,43.55,0,0,1,.71-7.81l10.32-56.56A9.15,9.15,0,0,0,396.86,142.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.24,213.66l19.88-64.75a9.15,9.15,0,0,1,8.74-6.47h0a9.15,9.15,0,0,1,9,10.79l-10.32,56.56a43.55,43.55,0,0,0-.71,7.81V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 296.05,
    y1: 295.4,
    x2: 296.05,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M346.28,318A43.54,43.54,0,0,1,293,287.24l-4.41-16.46a26.1,26.1,0,0,0-12.16-15.85L246,237.37a6.53,6.53,0,0,1,1.55-12l1.87-.5a43.48,43.48,0,0,1,33.18,4.3L299.47,239c3.59,2.08,9.5,5.4,13.22,7.23a44.9,44.9,0,0,1,23.61,28.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M346.46,237.23,344.24,215a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23L366,237.23a9.79,9.79,0,0,1-9.74,8.82h0A9.8,9.8,0,0,1,346.46,237.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.18,243.66l-7.91-20.94a12,12,0,0,1,8.14-15.87h0a12,12,0,0,1,15,9.68L345,238.61a9.79,9.79,0,0,1-7.13,11h0A9.79,9.79,0,0,1,326.18,243.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.07,237.58l-1.23-1.71a12,12,0,0,1,3.76-17.44h0a12,12,0,0,1,17,5.47l9.2,20.4a9.78,9.78,0,0,1-1.27,10.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M597,107.37a9.15,9.15,0,0,0-8.75,6.46l-19.87,64.76h0a12,12,0,0,0-23.64-3l-.88-.11a11.24,11.24,0,0,0-.62-1.71,43.39,43.39,0,0,0,1.07-9.54V162a6.52,6.52,0,0,0-11.14-4.61l-14.82,14.82h0l-22.4-75.73a9,9,0,0,0-17.53,4.3l14.43,73.71a43.57,43.57,0,0,1,.81,8.37V751H594.93V182.53a43.66,43.66,0,0,1,.71-7.82L606,118.16A9.15,9.15,0,0,0,597,107.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M568.34,178.59l19.87-64.76a9.15,9.15,0,0,1,8.75-6.46h0a9.15,9.15,0,0,1,9,10.79l-10.32,56.55a43.66,43.66,0,0,0-.71,7.82V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M518.31,172.16l-22.4-75.73A9,9,0,0,0,487.24,90h0a9,9,0,0,0-8.86,10.77l14.43,73.71a43.57,43.57,0,0,1,.81,8.37V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M537.15,286.08a43.53,43.53,0,0,1-43.53-43.53V207.66a26.13,26.13,0,0,1,7.65-18.47l31.86-31.85A6.52,6.52,0,0,1,544.27,162v2.24A43.49,43.49,0,0,1,531.52,195L524,202.49a4.32,4.32,0,0,0,.09,6.24,44.92,44.92,0,0,1,14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M546.56,202.16l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.27a9.8,9.8,0,0,1-9.74,8.82h0A9.8,9.8,0,0,1,546.56,202.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M543.18,173.68a12,12,0,0,1,1,6.21L542,202.16a9.8,9.8,0,0,1-9.75,8.82h0a9.81,9.81,0,0,1-9.31-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2961.09,272.5a12,12,0,0,1,24-.87h.13l-.65-6.54a12,12,0,0,1,12-13.23h0a12,12,0,0,1,11.72,9.29h0a43.23,43.23,0,0,1-1.63-11.75v-2.24a6.53,6.53,0,0,1,11.15-4.61l18,18h.19a12,12,0,0,1,9.26-4.35h0a12,12,0,0,1,12,13.17v21.88c0,.53.05,1.06.05,1.59v34.89c0,.62,0,1.23,0,1.85l0,421.39h-96.23V272.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2961.09,
    y1: 272.5,
    x2: 2961.09,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3057.27,
    y1: 269.02,
    x2: 3057.32,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3013.79,371.28a43.53,43.53,0,0,0,43.53-43.53V292.86a26.13,26.13,0,0,0-7.65-18.47l-31.85-31.85a6.53,6.53,0,0,0-11.15,4.61v2.24a43.53,43.53,0,0,0,12.75,30.78l7.51,7.52a4.31,4.31,0,0,1-.09,6.24,44.92,44.92,0,0,0-14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3055.8,284.07l1.46-14.62a12,12,0,0,0-12-13.23h0a12,12,0,0,0-9.26,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3009.18,263.77a9.72,9.72,0,0,0,.06,1.32l2.22,22.27a9.81,9.81,0,0,0,9.75,8.82h0a9.77,9.77,0,0,0,4.47-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2982.86,296.07l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.22,22.27a9.8,9.8,0,0,0,9.75,8.82h0A9.79,9.79,0,0,0,2982.86,296.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3006.3,287.36l2.22-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.8,9.8,0,0,0,9.74,8.82h0A9.8,9.8,0,0,0,3006.3,287.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1489.3,242.44a12,12,0,0,1,24-.87h.14l-.66-6.53a12,12,0,0,1,12-13.23h0a12,12,0,0,1,11.72,9.29h0a43.63,43.63,0,0,1-1.63-11.75v-2.24a6.53,6.53,0,0,1,11.15-4.62l18,18,.19,0a12,12,0,0,1,9.26-4.36h0a12,12,0,0,1,12,13.18v21.88q.06.8.06,1.59v34.89c0,.61,0,1.23,0,1.84l0,451.46H1489.3V242.44Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1489.3,
    y1: 242.44,
    x2: 1489.3,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1585.48,
    y1: 238.95,
    x2: 1585.54,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1542,341.22a43.53,43.53,0,0,0,43.53-43.53V262.8a26.11,26.11,0,0,0-7.65-18.47L1546,212.47a6.53,6.53,0,0,0-11.15,4.62v2.24a43.55,43.55,0,0,0,12.75,30.78l7.51,7.51a4.31,4.31,0,0,1-.08,6.24A44.89,44.89,0,0,0,1540.49,297"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1584,254l1.47-14.63a12,12,0,0,0-12-13.23h0a12,12,0,0,0-9.26,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1537.39,233.71q0,.64.06,1.32l2.23,22.26a9.79,9.79,0,0,0,9.74,8.82h0a9.61,9.61,0,0,0,4.47-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1511.08,266l2.22-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.8,9.8,0,0,0,9.74,8.82h0A9.8,9.8,0,0,0,1511.08,266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1534.51,257.29l2.23-22.26a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.26a9.79,9.79,0,0,0,9.74,8.82h0A9.79,9.79,0,0,0,1534.51,257.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2961.09,229.35a12,12,0,0,0-23.25-4.21l-1.18-.22.3-3a12,12,0,0,0-23.82-3.24l7.57-77.07a8.77,8.77,0,0,0-17.33-2.52l-14,72.74-2.84,2.84-14.58-75.58a8.77,8.77,0,0,0-17.33,2.52l7.55,76.87c.13,1.42.2,2.84.2,4.26v25.43c0,.51,0,1,0,1.53V284.6c0,.57,0,1.13,0,1.68l0,464.71h98.79V229.35ZM2913,220.62h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2961.09,
    y1: 229.35,
    x2: 2961.09,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2886.51,214.69l-14.58-75.58a8.75,8.75,0,0,0-8.6-7.1h0a8.77,8.77,0,0,0-8.73,9.62l7.55,76.87c.13,1.42.2,2.84.2,4.26l0,528.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2913,220.63l7.75-79A8.77,8.77,0,0,0,2912,132h0a8.75,8.75,0,0,0-8.6,7.1l-14,72.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2905.83,328.13a43.53,43.53,0,0,1-43.53-43.53V249.72a26.09,26.09,0,0,1,7.65-18.47l31.86-31.86A6.53,6.53,0,0,1,2913,204v2.24A43.56,43.56,0,0,1,2900.21,237l-7.52,7.51a4.32,4.32,0,0,0,.09,6.24,44.92,44.92,0,0,1,14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2915.24,244.21,2913,221.94a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.27A9.79,9.79,0,0,1,2925,253h0A9.8,9.8,0,0,1,2915.24,244.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2939.31,252.92l-2.23-22.26a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.26a9.79,9.79,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,2939.31,252.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2348.15,
    y: 95.29,
    width: 15.03,
    height: 12.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2363.18,117.57v-9.75h-27.56v18.85c.07-.29,18.32-8.67,18.32-8.67A11.51,11.51,0,0,1,2363.18,117.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2343.64,111.73h11.67a4,4,0,0,1,4,4v14a0,0,0,0,1,0,0h-19.68a0,0,0,0,1,0,0v-14A4,4,0,0,1,2343.64,111.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2366.38,164.18l-10,.39,0-.07,10-.45a12,12,0,1,0-3.44-23.69l-11.47,2.86v-.06l10.53-2.6a12,12,0,0,0,8.45-15.72h0a12,12,0,0,0-16.48-6.84l-18.32,8.67v-9.83l-18.51,8h0a43.53,43.53,0,0,0,10.56-28.4V94.16a6.53,6.53,0,0,0-11.15-4.61l-31.86,31.85a26.17,26.17,0,0,0-7.65,18.47v34.89c0,.78,0,1.55.07,2.32L2277,751h86.33V208.51l0-.22a10.44,10.44,0,0,0-.24-20.52l1.89.31a12,12,0,1,0,1.44-23.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2276.99,
    y1: 750.99,
    x2: 2277.06,
    y2: 173.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2343.67,184.65l19.2,3.08a10.46,10.46,0,0,1,8.45,13h0a10.46,10.46,0,0,1-13.78,7.11l-18.2-6.82a8.51,8.51,0,0,1-5.24-10.15h0A8.51,8.51,0,0,1,2343.67,184.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2344,165.06l22.36-.88a12,12,0,0,1,12.49,12.74h0a12,12,0,0,1-13.93,11.16l-22.09-3.57a9.79,9.79,0,0,1-8.22-10.26h0A9.79,9.79,0,0,1,2344,165.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2340.25,145.93l21.72-5.37a12,12,0,0,0,8.45-15.72h0a12,12,0,0,0-16.48-6.84l-20.23,9.57a9.8,9.8,0,0,0-5,12.14h0A9.79,9.79,0,0,0,2340.25,145.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2344,165.06l22.35-1a12,12,0,0,0,11.37-13.76h0a12,12,0,0,0-14.81-9.94l-21.72,5.41a9.8,9.8,0,0,0-7.32,10.92h0A9.8,9.8,0,0,0,2344,165.06Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2363.32,
    y1: 208.51,
    x2: 2363.32,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2320.53,218.29A43.53,43.53,0,0,1,2277,174.76V139.87a26.17,26.17,0,0,1,7.65-18.47l31.86-31.85a6.53,6.53,0,0,1,11.15,4.61V96.4a43.53,43.53,0,0,1-12.75,30.78l-7.51,7.52a4.31,4.31,0,0,0,.09,6.24A44.92,44.92,0,0,1,2322,174.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2335.62 126.67 2335.62 107.82 2363.18 107.82 2363.18 117.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2348.15,
    y: 95.29,
    width: 15.03,
    height: 12.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2335.62,
    y: 104.31,
    width: 5.01,
    height: 3.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2363.18,
    y1: 101.56,
    x2: 2355.66,
    y2: 101.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2335.62,
    y1: 116.84,
    x2: 2317.11,
    y2: 124.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2352.59,76.29,2354,80.5a.73.73,0,0,0,1.42-.11l1.85-10.52,4,15.91a5.89,5.89,0,0,1-2.56,6.52,5.91,5.91,0,0,1-6,0,5.86,5.86,0,0,1-2.55-6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2761,153.47a12,12,0,0,0-22.87-5.11l-1.45-.32.19-2a12,12,0,0,0-23.8-3.29l-.4-.09a12,12,0,0,0-.87-2.78,43.39,43.39,0,0,0,1.07-9.54v-2.23a6.53,6.53,0,0,0-11.15-4.62L2688,137.18h0l-7.2-72.67a9.31,9.31,0,0,0-9.26-8.38h0a9.3,9.3,0,0,0-9.3,9.3l0,106.83c0,.52-.06,1.05-.06,1.57v34.89c0,.61,0,1.21.05,1.82L2662.2,751H2761V153.47Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2760.99,
    y1: 153.47,
    x2: 2760.99,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2688,137.18l-7.2-72.67a9.31,9.31,0,0,0-9.26-8.38h0a9.3,9.3,0,0,0-9.3,9.3L2662.2,751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2705.74,252.25a43.53,43.53,0,0,1-43.54-43.53V173.83a26.09,26.09,0,0,1,7.65-18.46l31.86-31.86a6.53,6.53,0,0,1,11.15,4.62v2.23a43.57,43.57,0,0,1-12.75,30.79l-7.51,7.51a4.32,4.32,0,0,0,.08,6.24,44.89,44.89,0,0,1,14.57,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2715.15,168.33l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,2715.15,168.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2711.77,139.86a12,12,0,0,1,1,6.2l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0a9.8,9.8,0,0,1-9.31-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2739.21,177,2737,154.78a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23L2758.7,177a9.79,9.79,0,0,1-9.74,8.82h0A9.8,9.8,0,0,1,2739.21,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1289.2,213.6a12,12,0,0,0-22.87-5.11l-1.45-.32.2-2a12,12,0,0,0-23.81-3.3l-.4-.08A12,12,0,0,0,1240,200a43.39,43.39,0,0,0,1.07-9.54v-2.24a6.53,6.53,0,0,0-11.15-4.61l-13.67,13.67h0l-7.2-72.67a9.3,9.3,0,0,0-9.26-8.38h0a9.3,9.3,0,0,0-9.3,9.3l0,106.83c0,.52,0,1.05,0,1.57v34.89c0,.61,0,1.21,0,1.82l0,480.32h98.78V213.6Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1289.2,
    y1: 213.6,
    x2: 1289.2,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1216.25,197.31l-7.2-72.67a9.3,9.3,0,0,0-9.26-8.38h0a9.3,9.3,0,0,0-9.3,9.3L1190.42,751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1234,312.38a43.53,43.53,0,0,1-43.53-43.53V234a26.13,26.13,0,0,1,7.65-18.47l31.85-31.85a6.53,6.53,0,0,1,11.15,4.61v2.24a43.57,43.57,0,0,1-12.75,30.79l-7.51,7.51a4.32,4.32,0,0,0,.09,6.24,44.92,44.92,0,0,1,14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1243.36,228.46l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.27a9.79,9.79,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,1243.36,228.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1240,200a12,12,0,0,1,1,6.21l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0a9.8,9.8,0,0,1-9.31-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1267.42,237.17l-2.22-22.27a12,12,0,0,1,12-13.22h0a12,12,0,0,1,12,13.22l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0A9.8,9.8,0,0,1,1267.42,237.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M791.21,155.84a8.78,8.78,0,0,0-8.5,6.55L768.2,217.67a.09.09,0,0,1-.17,0l.88-70.12a9,9,0,0,0-9-9.1h0a9,9,0,0,0-8.9,7.71l-10.25,71.38a.09.09,0,0,1-.18,0L735.52,138a8.84,8.84,0,0,0-17.66.31l-2.22,79.33a.09.09,0,0,1-.17,0l-15.64-72.34a8.72,8.72,0,0,0-8.52-6.88h0a8.71,8.71,0,0,0-8.65,9.77l8.2,67.54a43.91,43.91,0,0,1,.32,5.25v2.65l0,0a43.48,43.48,0,0,0-25.93-8.45h-1.94a6.53,6.53,0,0,0-4.59,11.15l24.83,24.83a26.11,26.11,0,0,1,7.65,18.47v17h0V751H792.48V221.42a42.94,42.94,0,0,1,.43-6.1l7-49.47A8.78,8.78,0,0,0,791.21,155.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M691.17,223.64V221a43.91,43.91,0,0,0-.32-5.25l-8.2-67.54a8.71,8.71,0,0,1,8.65-9.77h0a8.72,8.72,0,0,1,8.53,6.88l15.64,72.34a.09.09,0,0,0,.17,0l2.22-79.33a8.84,8.84,0,0,1,8.84-8.59h0a8.84,8.84,0,0,1,8.82,8.28l5.08,79.52a.09.09,0,0,0,.18,0L751,146.14a9,9,0,0,1,8.89-7.71h0a9,9,0,0,1,9,9.1L768,217.65a.09.09,0,0,0,.17,0l14.51-55.28a8.78,8.78,0,0,1,8.5-6.55h0a8.78,8.78,0,0,1,8.69,10l-7,49.47a42.94,42.94,0,0,0-.43,6.1V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 691.17,
    y1: 750.99,
    x2: 691.17,
    y2: 286.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M734.7,330.22a43.53,43.53,0,0,1-43.53-43.53v-17a26.11,26.11,0,0,0-7.65-18.47l-24.83-24.83a6.53,6.53,0,0,1,4.59-11.15h1.94A43.52,43.52,0,0,1,696.16,228l15.73,15.73c3.09,3.09,6.31,6.05,9.55,9A44.93,44.93,0,0,1,736.21,286"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2864.33,160.33a9.13,9.13,0,0,0-8.74,6.46l-19.88,64.76h0a12,12,0,0,0-23.63-3l-.89-.11a11.24,11.24,0,0,0-.62-1.71,43.37,43.37,0,0,0,1.07-9.53v-2.24a6.53,6.53,0,0,0-11.14-4.62l-14.82,14.82h0l-22.4-75.73a9,9,0,0,0-17.53,4.3l14.43,73.72a43.39,43.39,0,0,1,.81,8.36V751H2862.3V235.49a43.66,43.66,0,0,1,.71-7.82l10.32-56.55A9.15,9.15,0,0,0,2864.33,160.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2835.71,231.55l19.88-64.76a9.13,9.13,0,0,1,8.74-6.46h0a9.15,9.15,0,0,1,9,10.79L2863,227.67a43.66,43.66,0,0,0-.71,7.82V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2785.68,225.12l-22.4-75.73a9,9,0,0,0-8.67-6.47h0a9,9,0,0,0-8.86,10.77l14.43,73.72a43.39,43.39,0,0,1,.81,8.36V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2804.52,339A43.53,43.53,0,0,1,2761,295.51V260.63a26.09,26.09,0,0,1,7.65-18.47l31.86-31.86a6.52,6.52,0,0,1,11.14,4.62v2.24a43.52,43.52,0,0,1-12.75,30.78l-7.51,7.51a4.32,4.32,0,0,0,.09,6.24A44.92,44.92,0,0,1,2806,294.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2813.93,255.12l-2.22-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0A9.8,9.8,0,0,1,2813.93,255.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2810.55,226.65a11.85,11.85,0,0,1,1,6.2l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.82h0a9.78,9.78,0,0,1-9.3-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1289.2,189.27V751H1388l0-504.79c0-.56,0-1.12,0-1.68V209.63c0-.51,0-1,0-1.53V182.68c0-1.43.06-2.85.2-4.26l7.55-76.88A8.76,8.76,0,0,0,1378.36,99l-14.58,75.57-2.84-2.84-14-72.73a8.76,8.76,0,0,0-17.33,2.51l7.56,77.07a12,12,0,0,0-23.81,3.25l.3,3-1.18.21a12,12,0,0,0-23.25,4.22Zm48.13-8.73Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1289.2,
    y1: 189.27,
    x2: 1289.2,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1363.78,174.6,1378.36,99a8.75,8.75,0,0,1,8.6-7.11h0a8.77,8.77,0,0,1,8.73,9.62l-7.55,76.88c-.14,1.41-.2,2.83-.2,4.26L1388,751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1337.33,180.54l-7.75-79a8.77,8.77,0,0,1,8.73-9.62h0a8.75,8.75,0,0,1,8.6,7.11l14,72.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1344.46,288.05A43.53,43.53,0,0,0,1388,244.52V209.63a26.11,26.11,0,0,0-7.65-18.47l-31.86-31.86a6.53,6.53,0,0,0-11.15,4.62v2.24a43.55,43.55,0,0,0,12.75,30.78l7.52,7.51a4.32,4.32,0,0,1-.09,6.24,44.94,44.94,0,0,0-14.57,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1335.05,204.12l2.22-22.26a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.26a9.79,9.79,0,0,0,9.74,8.82h0A9.8,9.8,0,0,0,1335.05,204.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1311,212.84l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.8,9.8,0,0,0,9.75,8.82h0A9.8,9.8,0,0,0,1311,212.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2664.23,86.29h0a9.14,9.14,0,0,0-8.74,6.47l-19.88,64.75h0a12,12,0,0,0-12-11.92h0a12,12,0,0,0-12,13.22l.34,3.39-2.79.55-.39-2.37a12,12,0,1,0-23.13,6.19l.3.79-2,.39a12,12,0,0,0-17-5.47h0a12,12,0,0,0-3.76,17.44l1.23,1.71L2550,173.06a43.48,43.48,0,0,0-33.18-4.3l-1.87.5a6.53,6.53,0,0,0-1.55,12l30.41,17.55a26.16,26.16,0,0,1,12.17,15.86l4.4,16.46a43.26,43.26,0,0,0,3.09,8.15h0V751h98.78V161.45a43.55,43.55,0,0,1,.71-7.81l10.32-56.56A9.15,9.15,0,0,0,2664.23,86.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2635.61,157.51l19.88-64.75a9.14,9.14,0,0,1,8.74-6.47h0a9.15,9.15,0,0,1,9,10.79l-10.32,56.56a43.55,43.55,0,0,0-.71,7.81V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2563.42,
    y1: 239.25,
    x2: 2563.42,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2613.65,261.87a43.54,43.54,0,0,1-53.32-30.78l-4.4-16.46a26.16,26.16,0,0,0-12.17-15.86l-30.41-17.55a6.53,6.53,0,0,1,1.55-12l1.87-.5a43.48,43.48,0,0,1,33.18,4.3l16.89,9.75c3.59,2.08,9.5,5.4,13.22,7.23a44.9,44.9,0,0,1,23.61,28.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2613.84,181.08l-2.23-22.27a12,12,0,0,1,12-13.22h0a12,12,0,0,1,12,13.22l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,2613.84,181.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2593.55,187.51l-7.91-20.94a12,12,0,0,1,8.14-15.87h0a12,12,0,0,1,15,9.68l3.61,22.08a9.79,9.79,0,0,1-7.13,11h0A9.79,9.79,0,0,1,2593.55,187.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2564.44,181.43l-1.23-1.71a12,12,0,0,1,3.76-17.44h0a12,12,0,0,1,17,5.47l9.2,20.4a9.78,9.78,0,0,1-1.27,10.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M992.87,153.47A12,12,0,0,0,970,148.36l-1.46-.32.2-2a12,12,0,0,0-23.81-3.29l-.4-.09a12,12,0,0,0-.86-2.78,44,44,0,0,0,1.07-9.54v-2.24a6.53,6.53,0,0,0-11.15-4.61l-13.67,13.67h0l-7.21-72.67a9.29,9.29,0,0,0-9.25-8.38h0a9.3,9.3,0,0,0-9.31,9.3l0,106.83c0,.52,0,1.05,0,1.57v34.89c0,.61,0,1.21,0,1.82l0,540.45h98.79V153.47Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 992.87,
    y1: 153.47,
    x2: 992.87,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M919.92,137.18l-7.21-72.67a9.29,9.29,0,0,0-9.25-8.38h0a9.3,9.3,0,0,0-9.31,9.3L894.08,751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M937.61,252.25a43.53,43.53,0,0,1-43.53-43.53V173.83a26.09,26.09,0,0,1,7.65-18.46l31.86-31.86a6.53,6.53,0,0,1,11.15,4.61v2.24A43.57,43.57,0,0,1,932,161.15l-7.52,7.51a4.32,4.32,0,0,0,.09,6.24,44.93,44.93,0,0,1,14.57,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M947,168.33l-2.22-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0A9.8,9.8,0,0,1,947,168.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M943.65,139.85a12,12,0,0,1,1,6.21l-2.23,22.27a9.8,9.8,0,0,1-9.75,8.82h0a9.8,9.8,0,0,1-9.3-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M971.09,177l-2.23-22.26a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23L990.58,177a9.79,9.79,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,971.09,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M895.82,154a9.15,9.15,0,0,0-8.75,6.46L867.2,225.25h0a12,12,0,0,0-23.64-3l-.88-.11a11.24,11.24,0,0,0-.62-1.71,43.39,43.39,0,0,0,1.07-9.54v-2.24A6.52,6.52,0,0,0,832,204l-14.82,14.82h0l-22.4-75.73a9,9,0,0,0-17.53,4.3l14.43,73.72a43.39,43.39,0,0,1,.81,8.36V751H893.79V229.19a43.66,43.66,0,0,1,.71-7.82l10.32-56.55A9.15,9.15,0,0,0,895.82,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M867.2,225.25l19.87-64.76a9.15,9.15,0,0,1,8.75-6.46h0a9.15,9.15,0,0,1,9,10.79L894.5,221.37a43.66,43.66,0,0,0-.71,7.82V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M817.17,218.82l-22.4-75.73a9,9,0,0,0-8.67-6.47h0a9,9,0,0,0-8.86,10.77l14.43,73.72a43.39,43.39,0,0,1,.81,8.36V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M836,332.74a43.53,43.53,0,0,1-43.53-43.53V254.32a26.09,26.09,0,0,1,7.65-18.46L832,204a6.52,6.52,0,0,1,11.14,4.61v2.24a43.53,43.53,0,0,1-12.75,30.79l-7.51,7.51a4.32,4.32,0,0,0,.09,6.24,44.92,44.92,0,0,1,14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M845.42,248.82l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0A9.79,9.79,0,0,1,845.42,248.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842,220.34a12,12,0,0,1,1,6.21l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.82h0a9.81,9.81,0,0,1-9.31-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1157.3,128.87l0,.06a46.1,46.1,0,0,1,4.1-3.93,4.36,4.36,0,0,0,1.48-4.16l-2.25-11.73a46.06,46.06,0,0,1,5-31.14V4a3,3,0,0,0-3-3h-74.16a3,3,0,0,0-2.1.87h0a3,3,0,0,0-.87,2.1V157a2.48,2.48,0,0,0,2.47,2.47h57.37a45,45,0,0,1,4.5-19.63l0,0h0a42.72,42.72,0,0,1,7.31-10.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1165.57,159.46h-77.63a2.48,2.48,0,0,1-2.47-2.47v-4.06h80.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1085.47,67.89l-10.56-13a9.57,9.57,0,0,1,10.42-15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1190.36,121.05a43.55,43.55,0,0,0-2-13l-9.66-30.91-13.15-42.11V78a46.13,46.13,0,0,0-5,31.12l2.25,11.73a4.38,4.38,0,0,1-1.49,4.17,44.94,44.94,0,0,0-16,34.45h-51.13V751h96.24Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1094.18,
    y1: 159.46,
    x2: 1094.18,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1137.71,203a43.53,43.53,0,0,1-43.53-43.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1085.74,2.74h76.31a1.78,1.78,0,0,1,1.78,1.78V81.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1165.57,78V4a3,3,0,0,0-3-3h-74.16a3,3,0,0,0-2.1.87h0a3,3,0,0,0-.87,2.1V157a2.48,2.48,0,0,0,2.47,2.47h57.37a45,45,0,0,1,16-34.47,4.34,4.34,0,0,0,1.47-4.15l-2.25-11.73A46.17,46.17,0,0,1,1167,75.6h0a6.53,6.53,0,0,1,11.74,1.57l9.66,30.91a43.55,43.55,0,0,1,2,13l.06,629.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1165.57,
    y1: 35.06,
    x2: 1178.72,
    y2: 77.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1085.47,67.89l-10.56-13a9.57,9.57,0,0,1,10.42-15.06"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1081.55,
    cy: 101.55,
    r: 9.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1081.55,
    cy: 82.4,
    r: 9.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1081.55,
    cy: 101.55,
    r: 9.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1081.55,
    cy: 82.4,
    r: 9.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1095.44,
    y: 11.27,
    width: 17.54,
    height: 17.54,
    rx: 8.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1104.21,
    cy: 20.04,
    r: 7.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1104.21,
    cy: 20.04,
    r: 5.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1124.94,64.72h7.82a.33.33,0,0,0,.33-.36,3,3,0,0,0-3-2.68H1121a3,3,0,0,0-3,2.68.33.33,0,0,0,.33.36h3a.34.34,0,0,1,.34.33v1.76a.34.34,0,0,1-.34.34h-3a.33.33,0,0,0-.33.33v1.17a.33.33,0,0,0,.33.33h3a.34.34,0,0,1,.34.33v1.76a.33.33,0,0,1-.34.33h-3a.34.34,0,0,0-.33.34V72.9a.34.34,0,0,0,.33.34h3a.33.33,0,0,1,.34.33v1.78a.34.34,0,0,1-.34.33h-3a.33.33,0,0,0-.33.35,3,3,0,0,0,3,2.69h9.12a3,3,0,0,0,3-2.69.32.32,0,0,0-.33-.35h-7.82a.33.33,0,0,1-.33-.33V73.57a.33.33,0,0,1,.33-.33h7.84a.33.33,0,0,0,.33-.34V71.75a.33.33,0,0,0-.33-.33h-7.84a.33.33,0,0,1-.33-.33V69.31a.33.33,0,0,1,.33-.33h7.84a.33.33,0,0,0,.33-.33V67.49a.33.33,0,0,0-.33-.33h-7.84a.33.33,0,0,1-.33-.33V65.05A.33.33,0,0,1,1124.94,64.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M994.14,185.91a8.77,8.77,0,0,1,8.49,6.55l14.51,55.27a.09.09,0,0,0,.18,0l-.88-70.12a9,9,0,0,1,9-9.1h0a9,9,0,0,1,8.89,7.71l10.26,71.39a.09.09,0,0,0,.17,0l5.09-79.52a8.84,8.84,0,0,1,17.65.32l2.22,79.32a.09.09,0,0,0,.17,0l15.64-72.35a8.73,8.73,0,0,1,8.53-6.88h0a8.72,8.72,0,0,1,8.66,9.78l-8.2,67.53a42,42,0,0,0-.32,5.25v2.68a43.56,43.56,0,0,1,25.94-8.46h1.93a6.53,6.53,0,0,1,4.59,11.15l-24.82,24.82a26.11,26.11,0,0,0-7.65,18.47v17h0V751H992.87V251.48a44.31,44.31,0,0,0-.43-6.09l-7-49.47A8.79,8.79,0,0,1,994.14,185.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1094.18,253.71v-2.66a42,42,0,0,1,.32-5.25l8.2-67.53a8.72,8.72,0,0,0-8.66-9.78h0a8.73,8.73,0,0,0-8.53,6.88l-15.64,72.35a.09.09,0,0,1-.17,0l-2.22-79.32a8.84,8.84,0,0,0-8.83-8.59h0a8.83,8.83,0,0,0-8.82,8.27l-5.09,79.52a.09.09,0,0,1-.17,0l-10.26-71.39a9,9,0,0,0-8.89-7.71h0a9,9,0,0,0-9,9.1l.88,70.12a.09.09,0,0,1-.18,0l-14.51-55.27a8.77,8.77,0,0,0-8.49-6.55h0a8.79,8.79,0,0,0-8.7,10l7,49.47a44.31,44.31,0,0,1,.43,6.09V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1094.18,
    y1: 750.99,
    x2: 1094.18,
    y2: 316.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1050.65,360.29a43.53,43.53,0,0,0,43.53-43.53v-17a26.11,26.11,0,0,1,7.65-18.47l24.82-24.82a6.53,6.53,0,0,0-4.59-11.15h-1.93A43.55,43.55,0,0,0,1089.19,258l-15.73,15.73c-3.09,3.1-6.32,6.05-9.55,9a44.91,44.91,0,0,0-14.78,33.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1488,195.93a8.79,8.79,0,0,0-8.5,6.55L1465,257.76c0,.09-.17.07-.17,0l.88-70.12a9,9,0,0,0-9-9.09h0a9,9,0,0,0-8.9,7.7l-10.25,71.39a.09.09,0,0,1-.18,0l-5.08-79.52a8.84,8.84,0,0,0-17.65.32l-2.22,79.32a.09.09,0,0,1-.18,0l-15.64-72.34a8.72,8.72,0,0,0-8.52-6.88h0a8.72,8.72,0,0,0-8.66,9.77l8.2,67.54a43.78,43.78,0,0,1,.32,5.25v2.65l0,0a43.56,43.56,0,0,0-25.93-8.46h-1.93a6.53,6.53,0,0,0-4.6,11.15l24.83,24.82a26.13,26.13,0,0,1,7.65,18.47v17h0V751H1489.3V261.5a42.8,42.8,0,0,1,.43-6.09l7-49.47A8.77,8.77,0,0,0,1488,195.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1388,263.73v-2.65a43.78,43.78,0,0,0-.32-5.25l-8.2-67.54a8.72,8.72,0,0,1,8.66-9.77h0a8.72,8.72,0,0,1,8.52,6.88l15.64,72.34a.09.09,0,0,0,.18,0l2.22-79.32a8.84,8.84,0,0,1,8.83-8.59h0a8.84,8.84,0,0,1,8.82,8.27l5.08,79.52a.09.09,0,0,0,.18,0l10.25-71.39a9,9,0,0,1,8.9-7.7h0a9,9,0,0,1,9,9.09l-.88,70.12c0,.1.15.12.17,0l14.51-55.28a8.79,8.79,0,0,1,8.5-6.55h0a8.77,8.77,0,0,1,8.69,10l-7,49.47a42.8,42.8,0,0,0-.43,6.09V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1387.99,
    y1: 750.99,
    x2: 1387.99,
    y2: 326.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1431.52,370.31A43.53,43.53,0,0,1,1388,326.78v-17a26.13,26.13,0,0,0-7.65-18.47l-24.83-24.82a6.53,6.53,0,0,1,4.6-11.15H1362A43.55,43.55,0,0,1,1393,268l15.73,15.73c3.09,3.1,6.31,6.05,9.55,9A44.94,44.94,0,0,1,1433,326.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1583.51,177.52a9.14,9.14,0,0,1,8.74,6.46l19.88,64.76h0a12,12,0,0,1,23.63-3l.88-.11a12.43,12.43,0,0,1,.62-1.71,44,44,0,0,1-1.07-9.54V232.1a6.53,6.53,0,0,1,11.15-4.61l14.82,14.82h0l22.4-75.73a9,9,0,0,1,17.53,4.3l-14.43,73.72a43.39,43.39,0,0,0-.81,8.36V751H1585.54V252.68a43.66,43.66,0,0,0-.71-7.82l-10.32-56.55A9.15,9.15,0,0,1,1583.51,177.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1612.13,248.74,1592.25,184a9.14,9.14,0,0,0-8.74-6.46h0a9.15,9.15,0,0,0-9,10.79l10.32,56.55a43.66,43.66,0,0,1,.71,7.82V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1662.16,242.31l22.4-75.73a9,9,0,0,1,8.66-6.47h0a9,9,0,0,1,8.87,10.77l-14.43,73.72a43.39,43.39,0,0,0-.81,8.36V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1643.32,356.23a43.53,43.53,0,0,0,43.53-43.53V277.81a26.13,26.13,0,0,0-7.65-18.47l-31.86-31.85a6.53,6.53,0,0,0-11.15,4.61v2.24a43.57,43.57,0,0,0,12.75,30.79l7.52,7.51a4.32,4.32,0,0,1-.09,6.24A44.89,44.89,0,0,0,1641.8,312"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1633.91,272.31l2.22-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.22,22.27a9.8,9.8,0,0,0,9.75,8.82h0A9.8,9.8,0,0,0,1633.91,272.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1637.28,243.83a12,12,0,0,0-1,6.21l2.23,22.27a9.79,9.79,0,0,0,9.75,8.82h0a9.8,9.8,0,0,0,9.3-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2463.38,216a8.77,8.77,0,0,1,8.49,6.55l14.51,55.28c0,.1.18.08.17,0l-.88-70.12a9,9,0,0,1,9-9.1h0a9,9,0,0,1,8.89,7.71l10.26,71.38a.09.09,0,0,0,.17,0l5.09-79.52a8.84,8.84,0,0,1,17.65.31l2.22,79.33a.09.09,0,0,0,.17,0l15.64-72.34a8.72,8.72,0,0,1,8.53-6.88h0a8.73,8.73,0,0,1,8.66,9.77l-8.21,67.54a43.77,43.77,0,0,0-.31,5.25v2.67a43.49,43.49,0,0,1,25.94-8.45h1.93a6.53,6.53,0,0,1,4.59,11.15l-24.82,24.83a26.11,26.11,0,0,0-7.65,18.47v17h0V751H2462.11V281.55a44.46,44.46,0,0,0-.43-6.1l-7-49.47A8.79,8.79,0,0,1,2463.38,216Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2563.42,283.77v-2.65a43.77,43.77,0,0,1,.31-5.25l8.21-67.54a8.73,8.73,0,0,0-8.66-9.77h0a8.72,8.72,0,0,0-8.53,6.88l-15.64,72.34a.09.09,0,0,1-.17,0l-2.22-79.33a8.84,8.84,0,0,0-8.83-8.59h0a8.83,8.83,0,0,0-8.82,8.28L2514,277.65a.09.09,0,0,1-.17,0l-10.26-71.38a9,9,0,0,0-8.89-7.71h0a9,9,0,0,0-9,9.1l.88,70.12c0,.1-.14.12-.17,0l-14.51-55.28a8.77,8.77,0,0,0-8.49-6.55h0a8.79,8.79,0,0,0-8.7,10l7,49.47a44.46,44.46,0,0,1,.43,6.1V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2563.42,
    y1: 750.99,
    x2: 2563.42,
    y2: 346.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2519.88,390.35a43.53,43.53,0,0,0,43.54-43.53v-17a26.11,26.11,0,0,1,7.65-18.47l24.82-24.83a6.53,6.53,0,0,0-4.59-11.15h-1.93a43.46,43.46,0,0,0-30.94,12.75l-15.73,15.73c-3.1,3.09-6.32,6.05-9.55,9a44.91,44.91,0,0,0-14.78,33.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3064.2,58.7c0-8.3,5.05-15,11.28-15s11.27,6.73,11.27,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3064.2,58.7c0-8.3,5.05-15,11.28-15s11.27,6.73,11.27,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3059.19,58.7V55.8a5,5,0,0,1,5-4.91h10a5,5,0,0,1,5,4.91v2.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 3059.19,
    y: 56.25,
    width: 20.04,
    height: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3059.19,58.7V55.8a5,5,0,0,1,5-4.91h10a5,5,0,0,1,5,4.91v2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3057.32,751h86.21l-.05-596.63H3043.32c4,8.22,7.41,13.47,15.82,14.76l-1.82.32Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3057.32,
    y1: 169.44,
    x2: 3057.32,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3143.48,
    y1: 154.36,
    x2: 3143.53,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3039.06,154.36h128.05l2.21-4.9V61.15L3166,58.7h-126.9V69.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M3038.45,58.7l-8.27,23.22-2.54,24.54,4.13,24.2,11.55,23.7H3091a23.74,23.74,0,0,0-2-9.6l-15.66-35.23A27.39,27.39,0,0,1,3071,98.4h0a27.39,27.39,0,0,1,6-17.12l10.92-13.65c2-2.54,3.13-8.93,3.13-8.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "3039.06 154.36 3167.11 154.36 3169.32 149.46 3066.45 149.46 3060.72 152.07 3039.06 154.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "3039.06 61.15 3169.32 61.15 3165.96 58.7 3039.06 58.7 3039.06 61.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3039.06,58.7h125.25a5,5,0,0,1,5,5v85.64a5,5,0,0,1-5,5H3038.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3104.2,56.25h20a0,0,0,0,1,0,0v2a.5.5,0,0,1-.5.5h-19a.5.5,0,0,1-.5-.5v-2A0,0,0,0,1,3104.2,56.25Z",
    transform: "translate(6228.44 114.95) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3111.68,
    y: 66.28,
    width: 12.53,
    height: 12.53,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3113.93,
    y: 68.53,
    width: 8.02,
    height: 8.02,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3111.68,
    y: 66.28,
    width: 12.53,
    height: 12.53,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 3134.24,
    y: 66.28,
    width: 25.05,
    height: 15.03,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 3136.74,
    y: 68.78,
    width: 20.04,
    height: 10.02,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 3139.25,
    y: 71.29,
    width: 15.03,
    height: 5.01,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3134.24,
    y: 66.28,
    width: 25.05,
    height: 15.03,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3062.33,170.39A26.86,26.86,0,0,1,3042,138.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3060.72,132.58l-22.27-2.22a12,12,0,0,0-13.23,12h0a12,12,0,0,0,13.23,12l22.27-2.23a9.8,9.8,0,0,0,8.82-9.74h0A9.8,9.8,0,0,0,3060.72,132.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3052,109.15l-22.26-2.23a12,12,0,0,0-13.23,12h0a12,12,0,0,0,13.23,12l22.26-2.23a9.79,9.79,0,0,0,8.82-9.74h0A9.79,9.79,0,0,0,3052,109.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3052,84.68l-22.26-2.22a12,12,0,0,0-13.23,12h0a12,12,0,0,0,13.23,12l22.26-2.23a9.79,9.79,0,0,0,8.82-9.74h0A9.8,9.8,0,0,0,3052,84.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3056.36,60.45l-22.27-2.22a12,12,0,0,0-13.23,12h0a12,12,0,0,0,13.23,12l22.27-2.23a9.79,9.79,0,0,0,8.82-9.74h0A9.8,9.8,0,0,0,3056.36,60.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3060.72,132.58l-22.27-2.22a12,12,0,0,0-13.23,12h0a12,12,0,0,0,13.23,12l22.27-2.23a9.8,9.8,0,0,0,8.82-9.74h0A9.8,9.8,0,0,0,3060.72,132.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3052,109.15l-22.26-2.23a12,12,0,0,0-13.23,12h0a12,12,0,0,0,13.23,12l22.26-2.23a9.79,9.79,0,0,0,8.82-9.74h0A9.79,9.79,0,0,0,3052,109.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3052,84.68l-22.26-2.22a12,12,0,0,0-13.23,12h0a12,12,0,0,0,13.23,12l22.26-2.23a9.79,9.79,0,0,0,8.82-9.74h0A9.8,9.8,0,0,0,3052,84.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3056.36,60.45l-22.27-2.22a12,12,0,0,0-13.23,12h0a12,12,0,0,0,13.23,12l22.27-2.23a9.79,9.79,0,0,0,8.82-9.74h0A9.8,9.8,0,0,0,3056.36,60.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3117.94,89.21A25.06,25.06,0,1,0,3143,114.26,25.06,25.06,0,0,0,3117.94,89.21Zm0,43.84a18.79,18.79,0,1,1,18.79-18.79A18.79,18.79,0,0,1,3117.94,133.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3117.94,
    cy: 114.26,
    r: 25.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 3117.94,
    cy: 114.26,
    r: 18.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 3117.94,
    cy: 114.26,
    r: 15.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3117.94,
    cy: 114.26,
    r: 10.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 3110.43,
    y: 108,
    width: 15.03,
    height: 12.53,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 3117.94,
    cy: 114.26,
    r: 18.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3117.94,
    cy: 114.26,
    r: 18.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4626,229.35a12,12,0,0,0-23.25-4.21l-1.17-.22.29-3a12,12,0,0,0-23.81-3.24l7.56-77.07a8.77,8.77,0,0,0-17.33-2.52l-14,72.74-2.84,2.84-14.57-75.58a8.77,8.77,0,0,0-17.33,2.52l7.54,76.87q.21,2.13.21,4.26v25.43c0,.51-.05,1-.05,1.53V284.6c0,.57,0,1.13.05,1.68L4527.21,751H4626V229.35Zm-48.13-8.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4551.42,214.69l-14.57-75.58a8.77,8.77,0,0,0-8.61-7.1h0a8.76,8.76,0,0,0-8.72,9.62l7.54,76.87q.21,2.13.21,4.26L4527.21,751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4577.87,220.63l7.75-79a8.76,8.76,0,0,0-8.72-9.62h0a8.77,8.77,0,0,0-8.61,7.1l-14,72.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4570.75,328.13a43.53,43.53,0,0,1-43.54-43.53V249.72a26.14,26.14,0,0,1,7.65-18.47l31.86-31.86a6.53,6.53,0,0,1,11.15,4.62v2.24A43.56,43.56,0,0,1,4565.12,237l-7.51,7.51a4.31,4.31,0,0,0,.09,6.24,44.92,44.92,0,0,1,14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4580.16,244.21l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,4580.16,244.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4235.21,153.47a12,12,0,0,0-22.87-5.11l-1.45-.32.19-2a12,12,0,0,0-23.8-3.29l-.4-.09a12,12,0,0,0-.87-2.78,43.39,43.39,0,0,0,1.07-9.54v-2.23a6.53,6.53,0,0,0-11.15-4.62l-13.67,13.67h0l-7.2-72.67a9.31,9.31,0,0,0-9.26-8.38h0a9.3,9.3,0,0,0-9.3,9.3l0,106.83c0,.52-.06,1.05-.06,1.57v34.89c0,.61,0,1.21.05,1.82L4136.42,751h98.79V153.47Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4235.21,
    y1: 153.47,
    x2: 4235.21,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4162.26,137.18l-7.2-72.67a9.31,9.31,0,0,0-9.26-8.38h0a9.3,9.3,0,0,0-9.3,9.3L4136.42,751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4180,252.25a43.53,43.53,0,0,1-43.53-43.53V173.83a26.09,26.09,0,0,1,7.65-18.46l31.86-31.86a6.53,6.53,0,0,1,11.15,4.62v2.23a43.57,43.57,0,0,1-12.75,30.79l-7.51,7.51a4.32,4.32,0,0,0,.08,6.24,44.89,44.89,0,0,1,14.57,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4189.37,168.33l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,4189.37,168.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4186,139.86a12,12,0,0,1,1,6.2l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0a9.8,9.8,0,0,1-9.31-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4213.43,177l-2.23-22.26a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23L4232.92,177a9.79,9.79,0,0,1-9.74,8.82h0A9.8,9.8,0,0,1,4213.43,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4230.91,147l84.93-84.94L4332.77,79a8.71,8.71,0,0,0,12.31,12.32L4362,108.28l-14.4,14.4-1.73-6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4215.61,218.74l-6.19-23.13a8.71,8.71,0,0,0-4.51-16.82l-6.2-23.13,147.17-39.43,6.2,23.13a8.71,8.71,0,1,0,4.51,16.82l6.19,23.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4324.89,193.76h0a12,12,0,0,1,8.14,15.87l-3.37,8.9h0V751h-94.45V243.61q0-20.48,1.92-40.88l1.76-18.66a53.51,53.51,0,0,0-.53-14.13l-1.85-10.82a6.53,6.53,0,0,1,6.44-7.63h0A21,21,0,0,1,4263.68,169h0a54.25,54.25,0,0,1,.32,16l-2.71,20.75a8.58,8.58,0,0,0,0,1.6l8.61-2.64h0l13.64-4.17-.09.24,3.71-1.08,0-.14,10.53-2.93h0l15-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4230.91,147l84.93-84.94L4332.77,79a8.71,8.71,0,0,0,12.31,12.32L4362,108.28l-14.4,14.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4329.67,
    y1: 218.53,
    x2: 4329.67,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4312,195l-7.92,20.93a9.79,9.79,0,0,1-11.69,6h0a9.8,9.8,0,0,1-7.13-11l1.85-11.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4283.5,200.55l-3.41,9a9.87,9.87,0,0,1-11.78,6h0a9.86,9.86,0,0,1-4.55-2.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4306.29,225.52l3.61-22.08a12,12,0,0,1,15-9.68h0a12,12,0,0,1,8.14,15.87l-7.92,20.94a9.78,9.78,0,0,1-11.69,6h0A9.79,9.79,0,0,1,4306.29,225.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4286.13,290.05a43.53,43.53,0,0,0,43.54-43.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4230.91,147l84.93-84.94L4332.77,79a8.71,8.71,0,0,0,12.31,12.32L4362,108.28l-14.4,14.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4285.06,
    y1: 105.2,
    x2: 4306.61,
    y2: 126.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4239.13,
    y1: 178.64,
    x2: 4223.98,
    y2: 182.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4295.46,
    y1: 163.54,
    x2: 4264.1,
    y2: 171.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4297.68,
    y1: 138.16,
    x2: 4310.07,
    y2: 184.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4263.94 138.19 4284.84 117.29 4282.38 114.83 4257.21 139.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4279.36 134.06 4290.48 122.93 4288.02 120.47 4272.63 135.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4330.75 120.28 4338.7 112.34 4336.24 109.87 4323.92 122.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4236.6 159.61 4219.06 164.31 4219.96 167.67 4237.19 163.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4257.73 157.55 4291.44 148.52 4290.54 145.16 4254.36 154.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4237.95 167.51 4221.12 172.02 4222.02 175.38 4238.53 170.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4262.42 164.56 4293.51 156.23 4292.6 152.87 4260.8 161.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4263.1 191.92 4300.39 181.93 4299.49 178.56 4263.58 188.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4237.85 195.08 4228.01 197.72 4228.91 201.08 4237.51 198.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4318.26,
    y: 170.62,
    width: 22.23,
    height: 3.48,
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 102.91, 1126.4)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4264.18 183.36 4298.32 174.22 4297.42 170.85 4264.42 179.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "4238.65 186.6 4225.94 190.01 4226.84 193.37 4238.31 190.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4278.5,246.52a44.88,44.88,0,0,0-14.45-33.31,8.65,8.65,0,0,1-2.76-7.45L4264,185a54.25,54.25,0,0,0-.32-16h0A21,21,0,0,0,4243,151.49h0a6.53,6.53,0,0,0-6.44,7.63l1.85,10.82a53.51,53.51,0,0,1,.53,14.13l-1.76,18.66q-1.92,20.39-1.92,40.88V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4236.27,213.2l-20.66,5.54-6.19-23.13a8.71,8.71,0,0,0-4.51-16.82l-6.2-23.13,147.17-39.43,6.2,23.13a8.71,8.71,0,1,0,4.51,16.82l6.19,23.12-101.55,27.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4319.87,143.06l14.49-3.88a5.35,5.35,0,0,0-6.57-3.79l-15.53,4.16a5.36,5.36,0,0,0-3.79,6.56l6.22-1.66,1.11,4.13-6.22,1.67.83,3.12,6.22-1.66,1.11,4.13-6.22,1.67.84,3.12,6.22-1.66,1.11,4.16-6.22,1.67a5.38,5.38,0,0,0,6.57,3.79l15.53-4.16a5.38,5.38,0,0,0,3.79-6.57l-14.49,3.88-1.11-4.16,14.49-3.88-.83-3.1-14.49,3.88-1.12-4.16,14.49-3.88-.83-3.1L4321,147.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4306.66,98.3l10.7-10.7a5.41,5.41,0,0,0-7.65,0l-11.47,11.47a5.43,5.43,0,0,0,0,7.65l4.59-4.59,3.06,3.05-4.6,4.59,2.31,2.31,4.59-4.59,3.06,3.05-4.59,4.59,2.3,2.31,4.59-4.59,3.08,3.07-4.59,4.59a5.4,5.4,0,0,0,7.64,0L4331.15,109a5.4,5.4,0,0,0,0-7.64l-10.7,10.7-3.07-3.08,10.7-10.7L4325.79,96l-10.7,10.7-3.07-3.08,10.7-10.7-2.29-2.28-10.7,10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4431,156.92a12,12,0,0,1,24-.87h.13l-.65-6.53a12,12,0,0,1,12-13.23h0a12,12,0,0,1,11.72,9.29h0a43.23,43.23,0,0,1-1.63-11.75v-2.24a6.53,6.53,0,0,1,11.15-4.62l18,18h.19a12,12,0,0,1,9.26-4.35h0a12,12,0,0,1,12,13.17v21.88c0,.53.05,1.06.05,1.59v34.89c0,.62,0,1.23,0,1.85l0,537H4431V156.92Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4430.98,
    y1: 156.92,
    x2: 4430.98,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4527.16,
    y1: 153.43,
    x2: 4527.21,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4483.68,255.7a43.53,43.53,0,0,0,43.53-43.53V177.28a26.11,26.11,0,0,0-7.65-18.47L4487.71,127a6.53,6.53,0,0,0-11.15,4.62v2.24a43.49,43.49,0,0,0,12.75,30.78l7.51,7.51a4.32,4.32,0,0,1-.09,6.24,45,45,0,0,0-14.56,33.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4525.69,168.49l1.46-14.62a12,12,0,0,0-12-13.23h0a12,12,0,0,0-9.26,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4479.07,148.19a9.72,9.72,0,0,0,.06,1.32l2.22,22.27a9.8,9.8,0,0,0,9.75,8.82h0a9.8,9.8,0,0,0,4.47-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4452.75,180.49l2.23-22.27A12,12,0,0,0,4443,145h0a12,12,0,0,0-12,13.23l2.22,22.27a9.8,9.8,0,0,0,9.75,8.82h0A9.79,9.79,0,0,0,4452.75,180.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4476.19,171.78l2.22-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.8,9.8,0,0,0,9.74,8.82h0A9.8,9.8,0,0,0,4476.19,171.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3936.33,197V751h98.78l0-497c0-.56,0-1.12,0-1.69V217.37c0-.51,0-1-.05-1.53V190.41q0-2.13.21-4.26l7.54-76.87a8.77,8.77,0,0,0-17.33-2.52l-14.58,75.58-2.84-2.84-14-72.74a8.77,8.77,0,0,0-17.33,2.52l7.56,77.07a12,12,0,0,0-23.82,3.24l.3,3-1.17.21a12,12,0,0,0-23.25,4.21Zm48.13-8.72Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3936.33,
    y1: 197,
    x2: 3936.33,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4010.9,182.34l14.58-75.58a8.77,8.77,0,0,1,8.61-7.1h0a8.76,8.76,0,0,1,8.72,9.62l-7.54,76.87q-.21,2.13-.21,4.26l.05,560.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3984.46,188.28l-7.75-79a8.76,8.76,0,0,1,8.72-9.62h0a8.77,8.77,0,0,1,8.61,7.1l14,72.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3991.58,295.79a43.53,43.53,0,0,0,43.53-43.54V217.37a26.11,26.11,0,0,0-7.65-18.47L3995.6,167a6.53,6.53,0,0,0-11.14,4.62v2.24a43.52,43.52,0,0,0,12.75,30.78l7.51,7.51a4.32,4.32,0,0,1-.09,6.24,44.92,44.92,0,0,0-14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3982.17,211.86l2.23-22.27a12,12,0,0,0-12-13.22h0a12,12,0,0,0-12,13.22l2.23,22.27a9.79,9.79,0,0,0,9.74,8.82h0A9.79,9.79,0,0,0,3982.17,211.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3958.1,220.58l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.22,22.27a9.8,9.8,0,0,0,9.75,8.81h0A9.79,9.79,0,0,0,3958.1,220.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4138.45,207.58a9.14,9.14,0,0,0-8.74,6.47l-19.88,64.75h0a12,12,0,0,0-23.63-3l-.88-.11a12.43,12.43,0,0,0-.62-1.71,43.3,43.3,0,0,0,1.07-9.53v-2.24a6.53,6.53,0,0,0-11.15-4.62l-14.82,14.82h0l-22.4-75.73a9,9,0,0,0-17.53,4.3l14.43,73.72a43.54,43.54,0,0,1,.81,8.36V751h101.31V282.74a43.55,43.55,0,0,1,.71-7.81l10.32-56.56A9.15,9.15,0,0,0,4138.45,207.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4109.83,278.8l19.88-64.75a9.14,9.14,0,0,1,8.74-6.47h0a9.15,9.15,0,0,1,9,10.79l-10.32,56.56a43.55,43.55,0,0,0-.71,7.81V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4059.8,272.37l-22.4-75.73a9,9,0,0,0-8.66-6.47h0a9,9,0,0,0-8.87,10.77l14.43,73.72a43.46,43.46,0,0,1,.81,8.36V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4078.64,386.3a43.53,43.53,0,0,1-43.53-43.54V307.88a26.11,26.11,0,0,1,7.65-18.47l31.86-31.86a6.53,6.53,0,0,1,11.15,4.62v2.24A43.55,43.55,0,0,1,4073,295.19l-7.51,7.51a4.31,4.31,0,0,0,.08,6.24,44.89,44.89,0,0,1,14.57,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4088.06,302.37l-2.23-22.26a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.22,22.26a9.8,9.8,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,4088.06,302.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4084.68,273.9a12,12,0,0,1,1,6.21l-2.23,22.26a9.79,9.79,0,0,1-9.75,8.82h0a9.79,9.79,0,0,1-9.3-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3736.72,125.78h0a9.15,9.15,0,0,1,8.75,6.46L3765.34,197h0a12,12,0,0,1,12-11.93h0a12,12,0,0,1,12,13.23l-.34,3.39,2.79.55.39-2.38a12,12,0,1,1,23.13,6.2l-.3.78,2,.4a12,12,0,0,1,17-5.47h0a12,12,0,0,1,3.75,17.44l-1.22,1.7,14.48-8.36a43.56,43.56,0,0,1,33.19-4.31l1.86.51a6.53,6.53,0,0,1,1.56,12l-30.41,17.55A26.1,26.1,0,0,0,3845,254.12l-4.41,16.45a44,44,0,0,1-3.08,8.16h0V751h-98.79v-550a43.65,43.65,0,0,0-.7-7.82l-10.32-56.55A9.14,9.14,0,0,1,3736.72,125.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3765.34,197l-19.87-64.76a9.15,9.15,0,0,0-8.75-6.46h0a9.14,9.14,0,0,0-9,10.79l10.32,56.55a43.65,43.65,0,0,1,.7,7.82V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3837.54,
    y1: 278.73,
    x2: 3837.54,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3787.31,301.36a43.53,43.53,0,0,0,53.31-30.79l4.41-16.45a26.1,26.1,0,0,1,12.17-15.86l30.41-17.55a6.53,6.53,0,0,0-1.56-12l-1.86-.51a43.56,43.56,0,0,0-33.19,4.31l-16.88,9.75c-3.59,2.07-9.51,5.39-13.23,7.23a44.93,44.93,0,0,0-23.61,28.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3787.12,220.57l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.79,9.79,0,0,0,9.75,8.82h0A9.79,9.79,0,0,0,3787.12,220.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3807.4,227l7.92-20.93a12,12,0,0,0-8.14-15.88h0a12,12,0,0,0-15,9.68L3788.58,222a9.79,9.79,0,0,0,7.13,11h0A9.79,9.79,0,0,0,3807.4,227Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3836.52,220.91l1.22-1.7a12,12,0,0,0-3.75-17.44h0a12,12,0,0,0-17,5.47l-9.21,20.39a9.8,9.8,0,0,0,1.27,10.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3938.36,187.54h0a9.15,9.15,0,0,0-8.74,6.46l-19.87,64.76h0a12,12,0,0,0-12-11.93h0a12,12,0,0,0-12,13.23l.34,3.39-2.79.55-.39-2.38a12,12,0,1,0-23.13,6.2l.3.78-2,.4a12,12,0,0,0-17-5.47h0a12,12,0,0,0-3.75,17.44l1.22,1.71-14.49-8.37a43.53,43.53,0,0,0-33.18-4.31l-1.87.51a6.53,6.53,0,0,0-1.55,12L3817.88,300a26.13,26.13,0,0,1,12.17,15.86l4.41,16.46a43.93,43.93,0,0,0,3.08,8.15h0V751h98.79V262.7a43.65,43.65,0,0,1,.7-7.82l10.32-56.55A9.14,9.14,0,0,0,3938.36,187.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3909.74,258.76,3929.61,194a9.15,9.15,0,0,1,8.74-6.46h0a9.14,9.14,0,0,1,9,10.79L3937,254.88a43.65,43.65,0,0,0-.7,7.82V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3837.54,
    y1: 340.49,
    x2: 3837.54,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3887.77,363.12a43.53,43.53,0,0,1-53.31-30.78l-4.41-16.46A26.13,26.13,0,0,0,3817.88,300l-30.41-17.55a6.53,6.53,0,0,1,1.55-12l1.87-.51a43.53,43.53,0,0,1,33.18,4.31l16.89,9.75c3.59,2.07,9.51,5.4,13.23,7.23A45,45,0,0,1,3877.8,320"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3888,282.33l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.27a9.8,9.8,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,3888,282.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3867.68,288.75l-7.92-20.93a12,12,0,0,1,8.14-15.88h0a12,12,0,0,1,15,9.68l3.61,22.09a9.78,9.78,0,0,1-7.13,11h0A9.79,9.79,0,0,1,3867.68,288.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3838.56,282.68l-1.22-1.71a12,12,0,0,1,3.75-17.44h0a12,12,0,0,1,17,5.47l9.21,20.4a9.78,9.78,0,0,1-1.27,10.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4330.94,216a8.77,8.77,0,0,1,8.49,6.55l14.51,55.28a.09.09,0,0,0,.17,0l-.88-70.12a9,9,0,0,1,9-9.1h0a9,9,0,0,1,8.89,7.71l10.26,71.38a.09.09,0,0,0,.17,0l5.08-79.52a8.84,8.84,0,0,1,17.66.31l2.22,79.33a.09.09,0,0,0,.17,0l15.64-72.34a8.72,8.72,0,0,1,8.53-6.88h0a8.73,8.73,0,0,1,8.66,9.77l-8.21,67.54a43.77,43.77,0,0,0-.31,5.25v2.67a43.49,43.49,0,0,1,25.94-8.45h1.93a6.53,6.53,0,0,1,4.59,11.15l-24.82,24.83a26.11,26.11,0,0,0-7.65,18.47v17h0V751H4329.66V281.55a44.45,44.45,0,0,0-.42-6.1l-7-49.47A8.79,8.79,0,0,1,4330.94,216Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4431,283.77v-2.65a43.77,43.77,0,0,1,.31-5.25l8.21-67.54a8.73,8.73,0,0,0-8.66-9.77h0a8.72,8.72,0,0,0-8.53,6.88l-15.64,72.34a.09.09,0,0,1-.17,0l-2.22-79.33a8.84,8.84,0,0,0-8.84-8.59h0a8.84,8.84,0,0,0-8.82,8.28l-5.08,79.52a.09.09,0,0,1-.17,0l-10.26-71.38a9,9,0,0,0-8.89-7.71h0a9,9,0,0,0-9,9.1l.88,70.12a.09.09,0,0,1-.17,0l-14.51-55.28a8.77,8.77,0,0,0-8.49-6.55h0a8.79,8.79,0,0,0-8.7,10l7,49.47a44.46,44.46,0,0,1,.43,6.1V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4430.98,
    y1: 750.99,
    x2: 4430.98,
    y2: 346.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4387.44,390.35A43.53,43.53,0,0,0,4431,346.82v-17a26.11,26.11,0,0,1,7.65-18.47l24.82-24.83a6.53,6.53,0,0,0-4.59-11.15h-1.93A43.46,43.46,0,0,0,4426,288.09l-15.74,15.73c-3.09,3.09-6.31,6.05-9.55,9a44.93,44.93,0,0,0-14.77,33.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3343.63,281.58a12,12,0,0,0-22.87-5.1l-1.45-.33.19-2a12,12,0,0,0-23.8-3.29l-.4-.09a12,12,0,0,0-.87-2.78,43.3,43.3,0,0,0,1.07-9.53v-2.24a6.53,6.53,0,0,0-11.15-4.62l-13.67,13.67h0l-7.2-72.67a9.31,9.31,0,0,0-9.26-8.38h0a9.3,9.3,0,0,0-9.3,9.3l0,106.83c0,.52-.06,1.05-.06,1.58v34.88c0,.61,0,1.22,0,1.82l0,412.34h98.79V281.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3343.63,
    y1: 281.58,
    x2: 3343.63,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3270.68,265.29l-7.2-72.67a9.31,9.31,0,0,0-9.26-8.38h0a9.3,9.3,0,0,0-9.3,9.3L3244.84,751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3288.38,380.37a43.54,43.54,0,0,1-43.54-43.54V302a26.15,26.15,0,0,1,7.65-18.47l31.86-31.86a6.53,6.53,0,0,1,11.15,4.62v2.24a43.56,43.56,0,0,1-12.75,30.78l-7.51,7.51a4.31,4.31,0,0,0,.09,6.24,44.92,44.92,0,0,1,14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3297.79,296.44l-2.23-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.82h0A9.79,9.79,0,0,1,3297.79,296.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3294.41,268a12,12,0,0,1,1,6.2l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.82h0a9.79,9.79,0,0,1-9.31-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3321.85,305.16l-2.22-22.27a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.23,22.27a9.79,9.79,0,0,1-9.74,8.81h0A9.8,9.8,0,0,1,3321.85,305.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3141.5,176.38a9.15,9.15,0,0,1,8.75,6.46l19.87,64.76h0a12,12,0,0,1,23.64-3l.88-.11a12.43,12.43,0,0,1,.62-1.71,43.39,43.39,0,0,1-1.07-9.54V231a6.53,6.53,0,0,1,11.15-4.61l14.82,14.82h0l22.39-75.73a9,9,0,0,1,17.54,4.3l-14.44,73.71a44.38,44.38,0,0,0-.81,8.37V751H3143.53V251.54a43.65,43.65,0,0,0-.7-7.82l-10.32-56.55A9.14,9.14,0,0,1,3141.5,176.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3170.12,247.6l-19.87-64.76a9.15,9.15,0,0,0-8.75-6.46h0a9.14,9.14,0,0,0-9,10.79l10.32,56.55a43.65,43.65,0,0,1,.7,7.82V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3220.16,241.17l22.39-75.73a9.05,9.05,0,0,1,8.67-6.48h0a9,9,0,0,1,8.87,10.78l-14.44,73.71a44.38,44.38,0,0,0-.81,8.37V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3201.31,355.09a43.53,43.53,0,0,0,43.53-43.53V276.67a26.13,26.13,0,0,0-7.65-18.47l-31.85-31.85a6.53,6.53,0,0,0-11.15,4.61v2.24A43.53,43.53,0,0,0,3206.94,264l7.51,7.52a4.32,4.32,0,0,1-.09,6.24,44.92,44.92,0,0,0-14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3191.9,271.17l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.8,9.8,0,0,0,9.75,8.82h0A9.8,9.8,0,0,0,3191.9,271.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3195.28,242.69a12,12,0,0,0-1,6.21l2.23,22.27a9.8,9.8,0,0,0,9.74,8.82h0a9.8,9.8,0,0,0,9.31-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3541.2,156.92a12,12,0,0,1,24-.87h.13l-.65-6.53a12,12,0,0,1,12-13.23h0a12,12,0,0,1,11.71,9.29h0a43.23,43.23,0,0,1-1.63-11.75v-2.24a6.53,6.53,0,0,1,11.14-4.62l18,18h.18a12,12,0,0,1,9.27-4.35h0a12,12,0,0,1,12,13.17v21.88c0,.53.05,1.06.05,1.59v34.89c0,.62,0,1.23,0,1.85l0,537H3541.2V156.92Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3541.2,
    y1: 156.92,
    x2: 3541.2,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3637.38,
    y1: 153.43,
    x2: 3637.44,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3593.91,255.7a43.53,43.53,0,0,0,43.53-43.53V177.28a26.11,26.11,0,0,0-7.65-18.47L3597.93,127a6.53,6.53,0,0,0-11.14,4.62v2.24a43.49,43.49,0,0,0,12.75,30.78l7.51,7.51a4.32,4.32,0,0,1-.09,6.24,45,45,0,0,0-14.56,33.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3635.92,168.49l1.46-14.63a12,12,0,0,0-12-13.22h0a12,12,0,0,0-9.27,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3589.29,148.19q0,.66.06,1.32l2.23,22.27a9.8,9.8,0,0,0,9.75,8.82h0a9.8,9.8,0,0,0,4.47-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3563,180.49l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.8,9.8,0,0,0,9.75,8.82h0A9.79,9.79,0,0,0,3563,180.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3586.41,171.78l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.22,22.27a9.8,9.8,0,0,0,9.75,8.82h0A9.8,9.8,0,0,0,3586.41,171.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3343.63,189.27V751h98.79l-.05-504.79c0-.56.05-1.12.05-1.68V209.63c0-.51,0-1-.05-1.53V182.68q0-2.15.21-4.26l7.54-76.88A8.76,8.76,0,0,0,3432.78,99l-14.57,75.57-2.84-2.84-14-72.73a8.76,8.76,0,0,0-17.33,2.51l7.56,77.07a12,12,0,0,0-23.81,3.25l.3,3-1.18.21a12,12,0,0,0-23.25,4.22Zm48.13-8.73Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3343.63,
    y1: 189.27,
    x2: 3343.63,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3418.21,174.6,3432.78,99a8.77,8.77,0,0,1,8.61-7.11h0a8.76,8.76,0,0,1,8.72,9.62l-7.54,76.88q-.21,2.12-.21,4.26l.06,568.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3391.76,180.54l-7.75-79a8.76,8.76,0,0,1,8.72-9.62h0a8.77,8.77,0,0,1,8.61,7.11l14,72.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3398.89,288.05a43.53,43.53,0,0,0,43.53-43.53V209.63a26.11,26.11,0,0,0-7.65-18.47l-31.86-31.86a6.53,6.53,0,0,0-11.15,4.62v2.24a43.55,43.55,0,0,0,12.75,30.78l7.51,7.51a4.31,4.31,0,0,1-.08,6.24,44.91,44.91,0,0,0-14.57,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3389.47,204.12l2.23-22.26a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.22,22.26a9.8,9.8,0,0,0,9.75,8.82h0A9.79,9.79,0,0,0,3389.47,204.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3365.41,212.84l2.23-22.27a12,12,0,0,0-12-13.23h0a12,12,0,0,0-12,13.23l2.23,22.27a9.8,9.8,0,0,0,9.74,8.82h0A9.8,9.8,0,0,0,3365.41,212.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3543.23,176.49h0a9.15,9.15,0,0,0-8.74,6.46l-19.88,64.76h0a12,12,0,0,0-12-11.93h0a12,12,0,0,0-12,13.23l.34,3.39-2.79.55-.39-2.38a12,12,0,1,0-23.13,6.2l.3.78-2,.39a12,12,0,0,0-17-5.47h0a12,12,0,0,0-3.76,17.45l1.23,1.7L3429,263.26a43.53,43.53,0,0,0-33.18-4.31l-1.87.51a6.53,6.53,0,0,0-1.55,12L3422.76,289a26.14,26.14,0,0,1,12.17,15.86l4.41,16.45a42.91,42.91,0,0,0,3.08,8.16h0V751h98.78V251.64a43.55,43.55,0,0,1,.71-7.81l10.32-56.56A9.14,9.14,0,0,0,3543.23,176.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3514.61,247.71,3534.49,183a9.15,9.15,0,0,1,8.74-6.46h0a9.14,9.14,0,0,1,9,10.78l-10.32,56.56a43.55,43.55,0,0,0-.71,7.81V751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3442.42,
    y1: 329.44,
    x2: 3442.42,
    y2: 750.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3492.65,352.06a43.51,43.51,0,0,1-53.31-30.78l-4.41-16.45A26.14,26.14,0,0,0,3422.76,289l-30.41-17.56a6.53,6.53,0,0,1,1.55-12l1.87-.51a43.53,43.53,0,0,1,33.18,4.31l16.89,9.75c3.59,2.07,9.51,5.39,13.22,7.22A44.92,44.92,0,0,1,3482.67,309"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3492.84,271.28,3490.61,249a12,12,0,0,1,12-13.23h0a12,12,0,0,1,12,13.23l-2.22,22.27a9.8,9.8,0,0,1-9.75,8.82h0A9.8,9.8,0,0,1,3492.84,271.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3472.56,277.7l-7.92-20.93a12,12,0,0,1,8.14-15.88h0a12,12,0,0,1,15,9.68l3.61,22.09a9.8,9.8,0,0,1-7.13,11h0A9.78,9.78,0,0,1,3472.56,277.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3443.44,271.62l-1.23-1.7a12,12,0,0,1,3.76-17.45h0a12,12,0,0,1,17,5.47l9.2,20.4a9.76,9.76,0,0,1-1.27,10.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3635.41,226.24a9.15,9.15,0,0,1,8.75,6.47L3664,297.46h0a12,12,0,0,1,23.64-3l.88-.11a11.24,11.24,0,0,1,.62-1.71,43.3,43.3,0,0,1-1.07-9.53v-2.24a6.53,6.53,0,0,1,11.14-4.62L3714.06,291h0l22.4-75.73a9,9,0,0,1,17.54,4.3l-14.44,73.72a43.46,43.46,0,0,0-.81,8.36V751H3637.44V301.4a42.57,42.57,0,0,0-.71-7.81L3626.42,237A9.14,9.14,0,0,1,3635.41,226.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3664,297.46l-19.87-64.75a9.15,9.15,0,0,0-8.75-6.47h0a9.14,9.14,0,0,0-9,10.79l10.31,56.56a42.57,42.57,0,0,1,.71,7.81V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3714.06,291l22.4-75.73a9,9,0,0,1,8.67-6.47h0A9,9,0,0,1,3754,219.6l-14.44,73.72a43.46,43.46,0,0,0-.81,8.36V751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3695.22,405a43.53,43.53,0,0,0,43.53-43.54V326.54a26.11,26.11,0,0,0-7.65-18.47l-31.86-31.86a6.53,6.53,0,0,0-11.14,4.62v2.24a43.5,43.5,0,0,0,12.75,30.78l7.51,7.51a4.32,4.32,0,0,1-.09,6.24,44.92,44.92,0,0,0-14.56,33.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3685.81,321l2.23-22.27a12,12,0,0,0-12-13.22h0a12,12,0,0,0-12,13.22l2.23,22.27a9.79,9.79,0,0,0,9.74,8.82h0A9.79,9.79,0,0,0,3685.81,321Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3689.19,292.56a12,12,0,0,0-1,6.2l2.22,22.27a9.8,9.8,0,0,0,9.75,8.82h0a9.79,9.79,0,0,0,9.31-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4626,229.35v-4.86a13,13,0,0,0-25,6.27l2.23,22.26a10.79,10.79,0,0,0,21.48,0l.29-2.93V751a1,1,0,0,0,1,1Zm-1.06,1.21-2.22,22.26a8.79,8.79,0,0,1-17.5,0L4603,230.56a11,11,0,1,1,21.95,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7,144.83a13.05,13.05,0,0,0-19.33,0A13.22,13.22,0,0,0,1,148.61V751H0a1,1,0,0,0,2,0V174.21l.29,2.93a10.79,10.79,0,0,0,21.48,0L26,154.87A13.07,13.07,0,0,0,22.7,144.83ZM24,154.68l-2.23,22.26a8.79,8.79,0,0,1-17.5,0L2.06,154.68a11,11,0,1,1,22,0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsFront);
export default __webpack_public_path__ + "static/media/hands_front.492f089bef15eefc9b0ee2b79dbfb3b9.svg";
export { ForwardRef as ReactComponent };